import {SUJETO_EXCLUIDO_TYPES} from '../constants/sujetoExcluido.types'
import {sujetoExcluidoInitialState} from '../initital-state/sujetoExcluido.state'
import {
  SujetoExcluido,
  SujetoExcluidoAction,
  SujetoExcluidoState,
} from '../interfaces/sujeto-excluido.interface'

const sujetoExcluidoReducer = (
  state: SujetoExcluido = sujetoExcluidoInitialState,
  action: SujetoExcluidoAction
): SujetoExcluidoState => {
  switch (action.type) {
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_CATALOGO_SUCURSAL:
      return {...state, catalogoSucursal: action.payload, sucursalesCargadas: true}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_CATALOGO_SERIE:
      return {...state, catalogoSerie: action.payload}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMCLIENTE_HANDLE_CHANGE:
      return {...state, formCliente: {...state.formCliente, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMCLIENTE_SET_ERRORS:
      return {...state, errorsFormCliente: {...state.errorsFormCliente, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE:
      return {...state, formProductos: {...state.formProductos, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS:
      return {...state, errorsFormProductos: {...state.errorsFormProductos, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_HANDLE_CHANGE_EDIT:
      return {...state, formProductosEdit: {...state.formProductosEdit, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_SET_ERRORS_EDIT:
      return {
        ...state,
        errorsFormProductosEdit: {...state.errorsFormProductosEdit, ...action.payload},
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMSUCURSAL_HANDLE_CHANGE:
      return {...state, formSucursal: {...state.formSucursal, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMSUCURSAL_SET_ERRORS:
      return {...state, errorsFormSucursal: {...state.errorsFormSucursal, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FORMPRODUCTOS_CLEAR:
      return {
        ...state,
        formProductos: sujetoExcluidoInitialState.formProductos,
        errorsFormProductos: sujetoExcluidoInitialState.errorsFormProductos,
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_ADD:
      return {
        ...state,
        arrayProductos: [...state.arrayProductos, action.payload],
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_EDIT:
      const array = state.arrayProductos.map((producto, i) =>
        i === state.productoSeleccionado ? state.formProductosEdit : producto
      )
      return {
        ...state,
        arrayProductos: array,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: sujetoExcluidoInitialState.formProductosEdit,
        errorsFormProductosEdit: sujetoExcluidoInitialState.errorsFormProductosEdit,
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_DELETE_SERVICIOS:
      let prods = state.arrayProductos.filter((prods) => prods.tipo === "p")
      return {...state, arrayProductos: prods}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SELECT_ONE:
      return {...state, productoSeleccionado: action.payload}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_DELETE_ONE:
      return {
        ...state,
        arrayProductos: [
          ...state.arrayProductos.filter((_, i) => i !== state.productoSeleccionado!),
        ],
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_CLEAR_ALL:
      return {...state, arrayProductos: []}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ARRAYPRODUCTOS_SET_CALCULOS:
      return {
        ...state,
        calculosArrayProductos: {...state.calculosArrayProductos, ...action.payload},
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_CLEAR_ALL:
      let datosEmisor = !action.payload ? state.datosEmisor : {}
      return {...sujetoExcluidoInitialState, datosEmisor}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_DATOS_EMISOR:
      return {...state, datosEmisor: {...state.datosEmisor, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_DATOS_FACTURA:
      return {...state, datosFacturaRes: {...state.datosFacturaRes, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_UUID:
      return {...state, datosUUID: {...state.datosUUID, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FACTURA_EMITIDA:
      return {...state, facturaEmitda: action.payload}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_OPCIONES_ACTIVA:
      return {...state, opcionesActiva: true}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALELIMINAR_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALELIMINAR_CLOSE:
      return {...state, modals: sujetoExcluidoInitialState.modals, productoSeleccionado: null}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALFACTURACION_OPEN:
      return {...state, modals: {...state.modals, ...action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEDITAR_OPEN:
      return {...state, modals: {...state.modals, activeEditar: true}, ...action.payload}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEDITAR_CLOSE:
      return {
        ...state,
        modals: {...state.modals, activeEditar: false},
        formProductosEdit: sujetoExcluidoInitialState.formProductosEdit,
        errorsFormProductosEdit: sujetoExcluidoInitialState.errorsFormProductosEdit,
      }
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALIMPRESION_OPEN:
      return {...state, modals: {...state.modals, activeImpresion: action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEMAIL_OPEN:
      return {...state, modals: {...state.modals, activeEmail: action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALANULAR_OPEN:
      return {...state, modals: {...state.modals, activeAnular: action.payload}}
    case SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ANULADO:
      return {...state, anulado: action.payload}
    default:
      return state
  }
}

export default sujetoExcluidoReducer
